module.exports = __webpack_public_path__ + "static/media/MISSIONS@3x.ccbc8149.png";